/* eslint-disable */
<template>
    <div id="pageDashboard">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex lg6 sm6 xs6>
                    <img src="static/FAO.png"  width="60%">
                </v-flex>
                <v-flex lg6 sm6 xs6>
                    <img src="static/logo.png" align="right"  width="50%">
                </v-flex>
                <!-- mini statistic start -->
                <v-flex lg3 sm6 xs12>
                    <mini-statistic
                            icon="fa fa-facebook"
                            :title="countall"
                            sub-title="الكل"
                            caption="إمرأة"

                            color="green"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 sm6 xs12>

                    <v-menu offset-y style="width: 100%">
                        <mini-statistic
                                icon="fa fa-facebook"
                                :title="countsfax"
                                sub-title="صفاقس"
                                caption="إمرأة"
                                style="width: 100%"
                                slot="activator"
                                color="indigo"
                        >
                        </mini-statistic>
                        <v-list>
                            <v-list-tile>
                                <v-list-tile-title><a style="color: #9c27b0">S2 : </a>{{s2}} <a style="color: #9c27b0">إمرأة</a></v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-title><a style="color: #9c27b0">S5 : </a>{{s5}} <a style="color: #9c27b0">إمرأة</a></v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>

                </v-flex>
                <v-flex lg3 sm6 xs12>

                    <v-menu offset-y style="width: 100%">
                        <mini-statistic
                                icon="fa fa-google"
                                :title="countgabes"
                                sub-title="قابس"
                                caption="إمرأة"
                                style="width: 100%"
                                slot="activator"
                                color="red"
                        >
                        </mini-statistic>
                        <v-list>
                            <v-list-tile>
                                <v-list-tile-title><a style="color: #9c27b0">G2 : </a>{{g2}} <a style="color: #9c27b0">إمرأة</a></v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-title><a style="color: #9c27b0">G5 : </a>{{g5}} <a style="color: #9c27b0">إمرأة</a></v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-flex>
                <v-flex lg3 sm6 xs12>
                    <mini-statistic
                            icon="fa fa-twitter"
                            :title="countmednin"
                            sub-title="مدنين"
                            caption="إمرأة"

                            color="light-blue"
                    >
                    </mini-statistic>
                </v-flex>
                <!-- mini statistic  end -->
                <v-flex lg12 sm12 xs12>
                    <v-layout row wrap>
                        <v-flex lg4 sm12 xs12>
                            <v-select
                                    :items="countries"
                                    v-model="e2"
                                    label="المدينة"
                                    v-on:change="changeRoute2(`${e2}`)"

                                    item-text="country_ar"
                                    class="input-group--focused"
                            ></v-select>
                        </v-flex>
                        <v-flex lg4 sm12 xs12>
                            <v-select
                                    :items="equetetype"
                                    v-model="e3"
                                    label="إختيارات"
                                    v-on:change="changeRoute(`${e3}`)"
                                    item-text="country_ar"
                                    item-value="country"
                                    class="input-group--focused"></v-select>

                        </v-flex>
                    </v-layout>
                </v-flex>
                <router-view> </router-view>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    /* eslint-disable */

    import Countries from '@/api/country';
    import Equetetype from '@/api/equetetype.js';

    import API from '@/api';
    import EChart from '@/components/chart/echart';
    import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
    import PostListCard from '@/components/widgets/card/PostListCard';
    import ProfileCard from '@/components/widgets/card/ProfileCard';
    import PostSingleCard from '@/components/widgets/card/PostSingleCard';
    import WeatherCard from '@/components/widgets/card/WeatherCard';
    import PlainTable from '@/components/widgets/list/PlainTable';
    import PlainTableOrder from '@/components/widgets/list/PlainTableOrder';
    import VWidget from '@/components/VWidget';
    import Material from 'vuetify/es5/util/colors';
    import VCircle from '@/components/circle/VCircle';
    import BoxChart from '@/components/widgets/chart/BoxChart';
    import ChatWindow from '@/components/chat/ChatWindow';
    import CircleStatistic from '@/components/widgets/statistic/CircleStatistic';
    import LinearStatistic from '@/components/widgets/statistic/LinearStatistic';
    import table1 from '@/components/table1';
    import table2 from '@/components/table2';
    import table3 from '@/components/table3';
    import table4 from '@/components/table4';
    import table5 from '@/components/table5';
    import table6 from '@/components/table6';
    import table7 from '@/components/table7';

    export default {
        components: {
            table1,
            table2,
            table3,
            table4,
            table5,
            table6,
            table7,
            VWidget,
            MiniStatistic,
            ChatWindow,
            VCircle,
            WeatherCard,
            PostSingleCard,
            PostListCard,
            ProfileCard,
            EChart,
            BoxChart,
            CircleStatistic,
            LinearStatistic,
            PlainTable,
            PlainTableOrder
        },
        data() {
            return {
                e2: null,
                e3: null,
                countriess:'الكل',
                type:'Q1',
                s2:'0',
                s5:'0',
                g2:'0',
                g5:'0',
                countries: Countries,
                color: Material,
                equetetype: Equetetype,
                countall:"+100",
                countsfax:"+100",
                countgabes:"+100",
                countmednin:"+100",
            }
        },
        computed: {
            activity() {
                return API.getActivity();
            },
            posts() {
                return API.getPost(3);
            },
            siteTrafficData() {
                return API.getMonthVisit;
            },
        },
        created(){
            this.fetchcount();
            this.group_count()

    },

    methods: {
            changeRoute(a) {
                this.type = a;

                if (this.type==='Q1'){
                    this.$router.push('/dashboard/table1/'+this.countriess);
                }
                if (this.type==='Q2'){
                    this.$router.push('/dashboard/table2/'+this.countriess);
                }
                if (this.type==='Q3'){
                    this.$router.push('/dashboard/table3/'+this.countriess);
                }
                if (this.type==='Q4'){
                    this.$router.push('/dashboard/table4/'+this.countriess);
                }
                if (this.type==='Q5'){
                    this.$router.push('/dashboard/table5/'+this.countriess);
                }
                if (this.type==='Q6'){
                    this.$router.push('/dashboard/table6/'+this.countriess);
                }
                if (this.type==='Q7'){
                    this.$router.push('/dashboard/table7/'+this.countriess);}
            },
            changeRoute2(a) {
                if (this.type==='Q1'){
                this.$router.push('/dashboard/table1/'+a);
                }
                if (this.type==='Q2'){
                    this.$router.push('/dashboard/table2/'+a);
                }
                if (this.type==='Q3'){
                    this.$router.push('/dashboard/table3/'+a);
                }
                if (this.type==='Q4'){
                    this.$router.push('/dashboard/table4/'+a);
                }
                if (this.type==='Q5'){
                    this.$router.push('/dashboard/table5/'+a);
                }
                if (this.type==='Q6'){
                    this.$router.push('/dashboard/table6/'+a);
                }
                if (this.type==='Q7'){
                    this.$router.push('/dashboard/table7/'+a);
                }
                this.countriess = a;
            },
            fetchcount() {
                this.$http.get('https://acg-generations.com/acg_laravel/public/count_pays',
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
                    var data = response.bodyText
                    var obj = JSON.parse(data);
                    this.countall=obj.count.all;
                    this.countsfax=obj.count.sfax;
                    this.countgabes=obj.count.gabes;
                    this.countmednin=obj.count.mednin;
                }, response => {
                    // error callback
                });
            },
        group_count() {
            this.$http.get('https://acg-generations.com/acg_laravel/public/group_pays',
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
                var data = response.bodyText
                var obj = JSON.parse(data);
                console.log(obj.count)
                this.s2=obj.count.sfaxS2.nbr;
                this.s5=obj.count.sfaxS5.nbr;
                this.g2=obj.count.gabesG2.nbr;
                this.g5=obj.count.gabesG5.nbr;
            }, response => {
                // error callback
            });
        },
        }

    };
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue